import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { c as l } from "./clsx-OuTLNxxd.js";
import { i as n } from "./index-DNCSvd9d.js";
const w = ({ color: t, size: s, opacity: o = 1, className: e }) => {
  const i = l(n({ color: t, size: s }), e);
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "13",
      height: "13",
      viewBox: "0 0 13 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: { "--opacity": o },
      children: [
        /* @__PURE__ */ r(
          "rect",
          {
            width: "15.7417",
            height: "1.7925",
            transform: "matrix(0.705882 0.708329 -0.705882 0.708329 1.63818 0.329956)",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ r(
          "rect",
          {
            width: "15.7113",
            height: "1.7925",
            transform: "matrix(0.705882 -0.708329 0.705882 0.708329 0.25 11.3788)",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};
export {
  w as C
};
